// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <section className="footer">
      <h1>© 2025 Jinnie Cho</h1>
    </section>
  );
};

export default Footer;
